<template>
<div class="w-full">
 <app-header></app-header>
  <div class="login-main-wrapper py-60">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 text-center">
        <div class="min-h-70vh relative-hidden">
          <login-screen :callback="toggleRegModal" ></login-screen>
          <register-modal :class="registerPopup ? 'active' : ''"  :modal="registerPopup" :callback="toggleRegModal"></register-modal>
        </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
 
</template>


<script>
import LoginScreen from '@/views/pageComponents/login/Login.vue';
import RegisterModal from '@/views/pageComponents/login/Register';
export default {
  name: 'Login',
  components: {
    LoginScreen,
    RegisterModal,
  },
  data() {
    return {
      registerPopup: false,
      forgotPassModal: false,
    }
  },
  mounted() {
   if(this.$route.query.logout){
     window.location.href = window.location.href.replace('?logout=1', '');
   }
  },
  methods: {
    toggleRegModal() {
      this.registerPopup = !this.registerPopup;
    },
    toggelForgotPassModal() {
     this.forgotPassModal = !this.forgotPassModal;
    }

  },
}
</script>
